import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { kenoBetStore } from '../../store/kenoBetStore';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';
import { userInfoStore } from '../../store/userInfoStore';
import { numpadValueValidation } from '../../core/helpers/numpadValueValidation';

const OkNumpadButton = observer(() => {
  const { setIsOpenNumpad } = kenoBetStore;
  const { setBetAmount, betAmount, limits } = userInfoStore;
  const t = useTranslation();

  const validateNumpadValue = useCallback(
    () => numpadValueValidation(betAmount, limits, setBetAmount),
    [betAmount, setBetAmount, limits]
  );

  const handleClick = useCallback(() => {
    validateNumpadValue();
    setIsOpenNumpad(false);
  }, [setIsOpenNumpad, validateNumpadValue]);

  return (
    <div className='numpad-bet-btn-block'>
      <div className='numpad-btn-accept-inner' onClick={handleClick}>
        <button className='numpad-btn-accept'>{t(TranslationKeys.Ok)}</button>
      </div>
    </div>
  );
});
export default OkNumpadButton;
